<div class="full-wrapper">
  <router-outlet></router-outlet>
</div>

<!-- Global Upload Progress Overlay -->
<app-upload-progress-overlay></app-upload-progress-overlay>
